<template>
    <div>

    </div>
</template>

<script>
export default {
    name: "CoverEditView"
}
</script>

<style scoped>

</style>